import React from 'react';
import { reduxForm, Field } from 'redux-form';
import FormError from '../../FormError';
import SelectSearchField from 'components/SelectSearchField';

let UpdateAccountForm = ({
  user,
  simoAccounts,
  handleSubmit,
  error,
  loading,
}) => {
  const simoAccountsOptions =
    simoAccounts && simoAccounts.length
      ? simoAccounts.map((acc) => ({ name: acc.name, value: acc.id }))
      : [];

  // fixes for the unavailable default options when user has simo account not returned from the accounts list
  if (
    user &&
    !simoAccountsOptions.find((acc) => acc.value === user.simo_account_id)
  ) {
    simoAccountsOptions.push({
      name: user.simo_account_name,
      value: user.simo_account_id,
    });
  }
  if (
    user &&
    !simoAccountsOptions.find(
      (acc) => acc.value === user.simo_default_account_id,
    )
  ) {
    simoAccountsOptions.push({
      name: user.simo_default_account_name,
      value: user.simo_default_account_id,
    });
  }

  return (
    <form onSubmit={handleSubmit}>
      <Field
        component={SelectSearchField}
        name="simo_account_id"
        label="Simo Account Name"
        options={simoAccountsOptions}
        placeholder="Select simo account name"
        hideEmptyWhenHasValue={true}
        formName="updateAccountForm"
      />
      <Field
        component={SelectSearchField}
        name="simo_default_account_id"
        label="Default Simo Account Name"
        options={simoAccountsOptions}
        placeholder="Select default simo account name"
        hideEmptyWhenHasValue={true}
        formName="updateAccountForm"
      />
      {error && <FormError error={error} />}
      <br />
      <button className="btn btn-primary" disabled={loading}>
        Save Account Names
      </button>
    </form>
  );
};

UpdateAccountForm = reduxForm({
  form: 'updateAccountForm',
  enableReinitialize: true,
})(UpdateAccountForm);

export default UpdateAccountForm;
